module.exports = __webpack_public_path__ + "static/media/visa-checkout.680e2260.svg";